export const RECURRENCE_OPTIONS = [
  { value: "none", labelKey: "todo.recurrenceNone" },
  { value: "daily", labelKey: "todo.recurrenceDaily" },
  { value: "weekdays", labelKey: "todo.recurrenceWeekdays" },
  { value: "weekly", labelKey: "todo.recurrenceWeekly" },
  { value: "monthly", labelKey: "todo.recurrenceMonthly" },
];
